import { gql } from '__generated__';

export default gql(`
  mutation SendRegistrationConfirmation($id: ID!) {
    sendRegistrationConfirmation(id: $id) {
      id
      to
      subject
      created_at
    }
  }
`);
